import WrapperExperientialEventsCard from './WrapperExperientialEventsCard';

export default WrapperExperientialEventsCard;
